import { Component, DestroyRef, inject, ViewChild } from '@angular/core';
import { of, take } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ButtonClickEvent,
  CacBaseDialogComponent,
  CacDialogLayoutComponent,
  CacImageUploaderComponent,
} from '@controladad/ng-base';
import { formControl } from '@al00x/forms';
import { AttachmentApiService, FileType, UploadResult } from '../../../services';
import { Validators } from '@angular/forms';

export interface ImageUploadDialogData {
  image?: UploadResult;
}
export interface ImageUploadDialogResult {
  image: UploadResult;
}

@Component({
  selector: 'feature-image-upload-dialog',
  standalone: true,
  imports: [CacDialogLayoutComponent, CacImageUploaderComponent],
  templateUrl: './image-upload-dialog.component.html',
  styleUrl: './image-upload-dialog.component.scss',
})
export class ImageUploadDialogComponent extends CacBaseDialogComponent<ImageUploadDialogData, ImageUploadDialogResult> {
  controller = formControl<string | UploadResult>(null, Validators.required);

  get options() {
    return {
      fileType: 'Blog' as FileType,
    };
  }

  onSubmit(e: ButtonClickEvent) {
    if (!this.controller.valid) return;

    this.submit({
      image: this.controller.value as UploadResult,
    });
    return;
  }
}
